export default {
    data() {
        return {
            productCategory: '',
            keyword: '',
            tireSizeW: '',
            tireSizeR: '',
            tireSizeD: ''
        };
    }
}